export default "__VITE_ASSET__CZdhYJga__"